import { Box, Stack } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  getCdnImageSrc,
  Image,
  responsive,
  VStack,
} from "goi_common";

export default function B2BProcessSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.warmGray50}>
      <VStack
        maxWidth={`${1200}px`}
        css={responsive({
          overflow: "hidden",
          padding: {
            base: "64px 24px",
            lg: "120px 24px",
          },
        })}
        width="100%"
      >
        <Box className={"gray900 lg_head_42_b head_24_b"}>도입 절차</Box>
        <Box className={"gray900 lg_head_28_m subtitle_18_m"}>
          최소 1주, 최대 2주 내에 빠르고 효율적으로{" "}
          <br className="lg_over_hidden" />
          서비스 도입을 도와드리고 있습니다.
        </Box>
        <Stack
          css={responsive({
            flexDirection: {
              base: "column",
              lg: "row",
            },
            padding: {
              base: "0 0 0",
              lg: "48px 0 0",
            },
          })}
          gap="14px"
          alignItems="center"
          justifyContent="center"
        >
          <VStack alignItems="center" gap="10px">
            <Box
              css={responsive({
                width: { base: "200px", lg: "160px" },
                height: "140px",
                overflow: "hidden",
                marginTop: { base: 0, lg: "12px" },
              })}
            >
              <Image src={getCdnImageSrc("b2b/collabo/process-1.png")} />
            </Box>
            <Box className="gray900 head_24_sb" textAlign="center">
              사전 미팅
            </Box>
            <Box className="gray900 body_16r" textAlign="center">
              자세한 상담을 통해 <br />
              고객사의 상황과 <br /> 니즈를 파악합니다
            </Box>
          </VStack>
          <ColorIcon
            name="arrow_right_small"
            size={40}
            color={colors.gray300}
            css={responsive({
              transform: { base: "rotate(90deg)", lg: "rotate(0deg)" },
            })}
          />
          <VStack alignItems="center" gap="10px">
            <Box
              css={responsive({
                width: { base: "200px", lg: "160px" },
                height: "140px",
                overflow: "hidden",
              })}
            >
              <Image src={getCdnImageSrc("b2b/collabo/process-2.png")} />
            </Box>
            <Box className="gray900 head_24_sb" textAlign="center">
              맞춤형 컨설팅
            </Box>
            <Box className="gray900 body_16r" textAlign="center">
              상조 서비스 계약 유형과
              <br />
              부가 서비스 항목을
              <br />
              확정합니다
            </Box>
          </VStack>
          <ColorIcon
            name="arrow_right_small"
            size={40}
            color={colors.gray300}
            css={responsive({
              transform: { base: "rotate(90deg)", lg: "rotate(0deg)" },
            })}
          />
          <VStack alignItems="center" gap="10px">
            <Box
              css={responsive({
                width: { base: "200px", lg: "160px" },
                height: "140px",
                overflow: "hidden",
              })}
            >
              <Image src={getCdnImageSrc("b2b/collabo/process-3.png")} />
            </Box>
            <Box className="gray900 head_24_sb" textAlign="center">
              계약 체결
            </Box>
            <Box className="gray900 body_16r" textAlign="center">
              모두싸인을 활용하여
              <br />
              서비스 공급 전자 계약을 <br /> 진행합니다
            </Box>
          </VStack>
          <ColorIcon
            name="arrow_right_small"
            size={40}
            color={colors.gray300}
            css={responsive({
              transform: { base: "rotate(90deg)", lg: "rotate(0deg)" },
            })}
          />

          <VStack alignItems="center" gap="10px">
            <Box
              css={responsive({
                width: { base: "200px", lg: "160px" },
                height: "140px",
                overflow: "hidden",
              })}
            >
              <Image src={getCdnImageSrc("b2b/collabo/process-4.png")} />
            </Box>
            <Box className="gray900 head_24_sb" textAlign="center">
              업무 개시
            </Box>
            <Box className="gray900 body_16r" textAlign="center">
              고객사 내부 공지 등 <br /> 초기 세팅 이후 <br /> 업무 지원을
              시작합니다
            </Box>
          </VStack>
          <ColorIcon
            name="arrow_right_small"
            size={40}
            color={colors.gray300}
            css={responsive({
              transform: { base: "rotate(90deg)", lg: "rotate(0deg)" },
            })}
          />
          <VStack alignItems="center" gap="10px">
            <Box
              css={responsive({
                width: { base: "200px", lg: "160px" },
                height: "140px",
                overflow: "hidden",
              })}
            >
              <Image src={getCdnImageSrc("b2b/collabo/process-5.png")} />
            </Box>
            <Box className="gray900 head_24_sb" textAlign="center">
              정기 미팅
            </Box>
            <Box className="gray900 body_16r" textAlign="center">
              1개월 마다 <br /> 현황을 보고하고 <br /> 개선 사항을 점검합니다
            </Box>
          </VStack>
        </Stack>
      </VStack>
    </VStack>
  );
}
